// imove-start: 数据上报

export default async function(ctx) {
  const { reportIns = null } = ctx.payload;
  ctx.setContext({
    reportIns,
  })
}